module.exports = __webpack_public_path__ + "img/1556077417.65b2299f.jpg";